import http from '../../config/http-common';
import myUserService from "@/services/modules/general/MyUser.service";

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "admin/user"

class userService {


    async from(state, authorization, token) {

        //Seta o account somente com as autorizações
        let temp = {

            authorization: authorization,
            token: token,
            tempPassword: false,
        }

        localStorage.removeItem('username')
        localStorage.setItem('account', JSON.stringify(temp))

        await myUserService.get().then((my_user) => {

            const user = my_user.user
            const tokenResponse = my_user.token

            let account = {
                domain: tokenResponse.domain,
                name: user.name,
                accountName: tokenResponse.accountName,
                accountPrefix: tokenResponse.accountPrefix,
                login: user.username,
                authorization: authorization,
                token: token,
                tempPassword: false,
                module: tokenResponse.module,
                custom: tokenResponse.custom,
                helpDocUrl: tokenResponse.helpDocUrl,
                enableAllCompanies: tokenResponse.enableAllCompanies,
                enableAllEnterprises: tokenResponse.enableAllEnterprises,
                companies: tokenResponse.companies
            }

            localStorage.setItem('account', JSON.stringify(account))
            localStorage.setItem('template', JSON.stringify(tokenResponse.template))
            state.$store.commit("setAccount", account)

            console.log(tokenResponse.template)




        }).catch(error => this.responseError(error))



    }

    async login(state, user, password, save_login) {

        const request = {username: user, password: password, platform: 'web'};
        return await http.customAxios.post("login", request).then((response) => {

            const login = response.data

            let account = {
                domain: login.domain,
                name: login.name,
                accountName: login.accountName,
                accountPrefix: login.accountPrefix,
                login: user,
                authorization: login.authorization,
                token: login.token,
                tempPassword: login.tempPassword,
                module: login.module,
                custom: login.custom,
                helpDocUrl: login.helpDocUrl,
                enableAllCompanies: login.enableAllCompanies,
                enableAllEnterprises: login.enableAllEnterprises,
                companies: login.companies
            }

            if (save_login) {
                localStorage.setItem('username', JSON.stringify(user))
            } else {
                localStorage.removeItem('username')
            }

            localStorage.setItem('account', JSON.stringify(account))
            localStorage.setItem('template', JSON.stringify(response.data.template))
            state.$store.commit("setAccount", account)

        })

    }

    async recoveryRequest(username) {

        const request = {username: username, platform: 'web'};
        return await http.customAxios.post("recovery/request", request).then((response) => response.data)

    }

    async recoverySubmit(username, recoveryToken, recoveryPin, password) {

        const request = {
            username: username,
            recoveryToken: recoveryToken,
            recoveryPin: recoveryPin,
            password: password
        };
        return await http.customAxios.post("recovery/submit", request).then((response) => response.data)

    }


    selectList(params) {
        return http.list(path + "/selectList", params);
    }


}

export default new userService();


